import { getInterface } from '@/utils/js/initVariable';
const prefixUrl = 'api/RegionAnalysisResultApi/'; // 区域ai解读
/**
 * 删除区域ai解读结果
 */
export const deleteRegionAnalysisResult = (workspaceId, id)=>{
  return getInterface.post(`${prefixUrl}deleteRegionAnalysisResult/${workspaceId}/${id}`);
}
/**
 * 新增/修改 区域ai解读结果
 * @param {*} id 工作空间id
 * @param {*} data 
 * @returns 
 */
export const saveOrUpdateRegionAnalysisResult = (id, data)=>{
  return getInterface.post(`${prefixUrl}saveOrUpdateRegionAnalysisResult/${id}`, data);
}
// 查看解读结果
export const queryRegionAnalysisResult = (id)=>{
  return getInterface.post(`${prefixUrl}queryRegionAnalysisResult/${id}`, {});
}
